function applyUpsellStyleIfNeeded() {
  const productSections = document.querySelectorAll('[id*="ProductSection"]');

  let shouldApply = false;
  productSections.forEach(section => {
    if (section.querySelector('.bss-lock-element, .bss-hide-atc')) {
      shouldApply = true;
    }
  });

  if (!shouldApply) return;

  const upsell = document.querySelector('section-store--upsell-block');
  if (!upsell || !upsell.shadowRoot) return;

  const shadow = upsell.shadowRoot;
  const upsellVariantOption = document.querySelector('section-store--upsell-block--selector-options');
  const upsellShadowRoot = upsellVariantOption.shadowRoot;

  if (shadow.querySelector('#custom-hide-atc-style')) return;
  if (upsellShadowRoot.querySelector('#custom-hide-atc-style')) return;

  const style = document.createElement('style');
  style.id = 'custom-hide-atc-style';
  style.textContent = `
    .add-to-cart {
      display: none !important;
    }
    .price,.variant-price {
      display: none!important;
    }
  `;

  shadow.appendChild(style);
  const clonedStyle = style.cloneNode(true);
  upsellShadowRoot.appendChild(clonedStyle);
  
}

const observer = new MutationObserver(() => {
  applyUpsellStyleIfNeeded();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

applyUpsellStyleIfNeeded();
